// services/guestAssignmentService.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Crear nueva asignacion
export async function createAssignment(data) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments`, data);
    return res.data;
  } catch (err) {
    console.error('Error creating assignment:', err);
    throw new Error(err.response?.data?.message || 'Error al crear la asignacion');
  }
}

// Obtener todas las asignaciones
export async function getAssignments(params = {}) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments`, { params });
    return res.data;
  } catch (err) {
    console.error('Error getting assignments:', err);
    throw new Error(err.response?.data?.message || 'Error al obtener asignaciones');
  }
}

// Obtener asignacion por token
export async function getAssignmentByToken(token) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/token/${token}`);
    return res.data;
  } catch (err) {
    console.error('Error getting assignment by token:', err);
    throw new Error(err.response?.data?.message || 'Link invalido o expirado');
  }
}

// Guardar asignacion
export async function saveAssignment(token, data) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/token/${token}/save`, data);
    return res.data;
  } catch (err) {
    console.error('Error saving assignment:', err);
    throw new Error(err.response?.data?.message || 'Error al guardar las asignaciones');
  }
}

// Eliminar asignacion
export async function deleteAssignment(id) {
  try {
    const res = await axios.delete(`${API_BASE}/api/guest-assignments/${id}`);
    return res.data;
  } catch (err) {
    console.error('Error deleting assignment:', err);
    throw new Error(err.response?.data?.message || 'Error al eliminar la asignacion');
  }
}

// Obtener detalles de asignacion
export async function getAssignmentDetails(id) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/${id}`);
    return res.data;
  } catch (err) {
    console.error('Error getting assignment details:', err);
    throw new Error(err.response?.data?.message || 'Error al obtener detalles');
  }
}

// Exportar a CSV
export async function exportAssignment(id) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/${id}/export`, {
      responseType: 'blob'
    });
    
    // Crear enlace de descarga
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `asignacion-${id}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (err) {
    console.error('Error exporting assignment:', err);
    throw err;
  }
}

// Export assignment as XLSX with two sheets
export async function exportAssignmentXlsx(id, files = {}) {
  try {
    const formData = new FormData();
    if (files.mapCasaBlob) formData.append('mapCasa', files.mapCasaBlob, 'mapCasa.png');
    if (files.mapBoutiqueBlob) formData.append('mapBoutique', files.mapBoutiqueBlob, 'mapBoutique.png');

    const res = await axios.post(`${API_BASE}/api/guest-assignments/${id}/export-xlsx`, formData, {
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `asignacion-${id}.xlsx`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (err) {
    console.error('Error exporting xlsx:', err);
    throw err;
  }
}

// Actualizar el huésped asignado a una habitación específica de la boda
export async function updateAssignmentRoomGuest(assignmentId, roomId, { guestName, guestWhatsapp }) {
  try {
    const res = await axios.patch(
      `${API_BASE}/api/guest-assignments/${assignmentId}/rooms/${roomId}/guest`,
      { guestName, guestWhatsapp }
    );
    return res.data;
  } catch (err) {
    console.error('Error updating room guest:', err);
    throw new Error(err.response?.data?.message || 'Error al asignar huésped a la habitación');
  }
}
// Carga masiva desde Excel (con archivo)
export async function bulkUploadFile(file) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const res = await axios.post(`${API_BASE}/api/guest-assignments/bulk`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  } catch (err) {
    console.error('Error bulk upload file:', err);
    throw new Error(err.response?.data?.message || 'Error al procesar el archivo');
  }
}

// Carga masiva desde JSON
export async function bulkUpload(assignments) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/bulk`, { assignments });
    return res.data;
  } catch (err) {
    console.error('Error bulk upload:', err);
    throw new Error(err.response?.data?.message || 'Error en carga masiva');
  }
}

// Reparar indices problematicos
export async function fixIndexes() {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/maintenance/fix-indexes`);
    return res.data;
  } catch (err) {
    console.error('Error fixing indexes:', err);
    throw new Error(err.response?.data?.message || 'Error al reparar indices');
  }
}

// Reenviar email de invitacion
export async function resendInvitationEmail(id) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/${id}/resend-email`);
    return res.data;
  } catch (err) {
    console.error('Error resending email:', err);
    throw new Error(err.response?.data?.message || 'Error al reenviar el email');
  }
}

// Seed de habitaciones de asignacion
export async function seedAssignmentRooms() {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/admin/seed-rooms`);
    return res.data;
  } catch (err) {
    console.error('Error seeding rooms:', err);
    throw new Error(err.response?.data?.message || 'Error al sembrar habitaciones');
  }
}

// Obtener todas las habitaciones de asignacion
export async function getAssignmentRooms(params = {}) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/admin/rooms`, { params });
    return res.data;
  } catch (err) {
    console.error('Error getting assignment rooms:', err);
    throw new Error(err.response?.data?.message || 'Error al obtener habitaciones');
  }
}

// 🆕 NUEVO: Obtener códigos de descuento para una asignación
export async function getDiscountCodesForAssignment(assignmentId) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/${assignmentId}/discount-codes`);
    return res.data;
  } catch (err) {
    console.error('Error getting discount codes:', err);
    throw new Error(err.response?.data?.message || 'Error al obtener códigos de descuento');
  }
}

// 🆕 NUEVO: Enviar código de descuento por WhatsApp
export async function sendDiscountCodeWhatsApp(assignmentId, discountCodeId, pricing = null, groups = null) {
  try {
    const payload = {};
    if (discountCodeId) payload.discountCodeId = discountCodeId;
    if (pricing) payload.pricing = pricing;
    if (groups) payload.groups = groups;
    const res = await axios.post(`${API_BASE}/api/guest-assignments/${assignmentId}/send-discount-whatsapp`, payload);
    return res.data;
  } catch (err) {
    console.error('Error sending discount code:', err);
    throw new Error(err.response?.data?.message || 'Error al enviar código de descuento');
  }
}

// Guardar grupos de fechas para una asignación
export async function saveAssignmentGroups(assignmentId, groups) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/${assignmentId}/groups`, { groups });
    return res.data;
  } catch (err) {
    console.error('Error saving groups:', err);
    throw new Error(err.response?.data?.message || 'Error guardando grupos');
  }
}

// Consultar token de precio preaprobado
export async function getGuestPriceToken(token) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/guest-price-token/${token}`);
    return res.data;
  } catch (err) {
    console.error('Error getting guest price token:', err);
    throw new Error(err.response?.data?.message || 'Token inválido');
  }
}

// Consumir token
export async function consumeGuestPriceToken(token) {
  try {
    const res = await axios.post(`${API_BASE}/api/guest-assignments/guest-price-token/${token}/consume`);
    return res.data;
  } catch (err) {
    console.error('Error consuming token:', err);
    throw new Error(err.response?.data?.message || 'Error consumiendo token');
  }
}

// Obtener estado de pagos cruzando huéspedes con reservas
export async function getPaymentStatus(assignmentId) {
  try {
    const res = await axios.get(`${API_BASE}/api/guest-assignments/${assignmentId}/payment-status`);
    return res.data;
  } catch (err) {
    console.error('Error getting payment status:', err);
    throw new Error(err.response?.data?.message || 'Error al obtener estado de pagos');
  }
}
